import React from 'react';
import {useDispatch} from 'react-redux';

import standaloneLocalization from '../../../config/standaloneConfig/standaloneLocalization';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import networkStatusService from '../../../services/networkStatusService';
import {setNotificationInfo} from '../../../state/ducks/global';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import helpers from '../../../utils/helpers';

const ConnectionTrackButton = (props) => {
    const {button: Component, onClick, onChange, isOnlineCheckOff, ...restProps} = props;
    const dispatch = useDispatch();
    const [eventName, eventHandler] = getEventHandlerData({onClick, onChange});
    const offlineHandler = () => {
        const localizedStrings = getLocalizedStrings();
        const text = localizedStrings
            ? localizedStrings[localizationKeys.NO_INTERNET_CONNECTION_SCENARIO_2_NOTIFICATION_TEXT]
            : standaloneLocalization.NO_INTERNET_CONNECTION_SCENARIO_2_NOTIFICATION_TEXT;

        dispatch(setNotificationInfo(text, elementsTesIds.ABOUT_MY_DEVICE_OFFLINE_NOTIFICATION));
    };

    return (
        <Component
            {...restProps}
            {...{
                [eventName]: (e) => {
                    if (networkStatusService.isOnline() || isOnlineCheckOff) {
                        helpers.runFunction(eventHandler, e);
                    } else {
                        if (typeof e?.preventDefault === 'function') {
                            e.preventDefault();
                        }
                        offlineHandler();
                    }
                },
            }}
        />
    );
};

export default ConnectionTrackButton;

const getEventHandlerData = ({onClick, onChange}) => {
    if (onClick) {
        return ['onClick', onClick];
    }
    if (onChange) {
        return ['onChange', onChange];
    }
    return ['onClick'];
};
